module.exports = __webpack_public_path__ + "img/not_found_error.ea8c72c6.svg";